module.exports = __webpack_public_path__ + "static/media/profiles.747ade5e.svg";